import useRemainingMinutes from 'hooks/useRemainingMinutes';

import './index.css';

const CongratulationsModalFooter = ({
  handleContinueTour,
  handleTalkToExpert,
  handleSkip,
  handleContinueTesting,
}) => {
  const { kFormatedMinutes } = useRemainingMinutes();
  return (
    <div className="modal-footer-section">
      <div className="remaining-minutes-container">
        * You now have access to {kFormatedMinutes} minutes of free trial
      </div>
      <div className="footer-button-container">
        <div className="footer-button-primary-container">
          <button
            onClick={handleContinueTour}
            className="modal-footer-button footer-button-primary modal-footer-button-continue-tour"
          >
            Continue Tour
          </button>
          <button
            onClick={handleTalkToExpert}
            className="modal-footer-button footer-button-secondary modal-footer-button-expert"
          >
            Talk to an expert
          </button>
          <button
            onClick={handleContinueTesting}
            className="modal-footer-button footer-button-secondary modal-footer-button-continue-testing modal-footer-button-hidden"
          >
            Continue Testing
          </button>
        </div>
        <button
          className="modal-footer-button footer-skip-now-button"
          onClick={handleSkip}
        >
          Skip for now
        </button>
      </div>
    </div>
  );
};

export default CongratulationsModalFooter;
